export default "__VITE_ASSET__mZJuuHm1__"